"use client";

import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useState } from "react";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import HomeHeader from "./home-header";
import SearchBar from "./search-bar";
import { useMapState } from "./map-state-provider";
const MapHomeHeader = () => {
  const $ = _c(24);
  const pathname = usePathname();
  const router = useRouter();
  const searchParams = useSearchParams();
  let t0;
  if ($[0] !== searchParams) {
    t0 = searchParams.get("address");
    $[0] = searchParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const searchedAddress = t0;
  let t1;
  if ($[2] !== searchParams) {
    t1 = searchParams.get("lon");
    $[2] = searchParams;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const longitude = t1;
  let t2;
  if ($[4] !== searchParams) {
    t2 = searchParams.get("lat");
    $[4] = searchParams;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const latitude = t2;
  const hasValidSearch = Boolean(searchedAddress && longitude && latitude);
  const [inputAddress, setInputAddress] = useState(searchedAddress ?? "");
  const {
    isSearchComplete,
    setSearchComplete
  } = useMapState();
  let t3;
  if ($[6] !== pathname || $[7] !== router || $[8] !== searchParams || $[9] !== setSearchComplete) {
    t3 = (coords, address) => {
      const params = new URLSearchParams(searchParams.toString());
      params.set("address", address);
      params.set("lon", coords[0].toString());
      params.set("lat", coords[1].toString());
      setInputAddress(address);
      setSearchComplete(false);
      router.push(`${pathname}?${params.toString()}`, {
        scroll: false
      });
    };
    $[6] = pathname;
    $[7] = router;
    $[8] = searchParams;
    $[9] = setSearchComplete;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const handleSearchChange = t3;
  let t4;
  if ($[11] !== setSearchComplete) {
    t4 = () => {
      setInputAddress("");
      setSearchComplete(false);
    };
    $[11] = setSearchComplete;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  const handleHomeIconClick = t4;
  const t5 = hasValidSearch && isSearchComplete;
  let t6;
  if ($[13] !== searchParams) {
    t6 = searchParams.toString();
    $[13] = searchParams;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== handleSearchChange || $[16] !== inputAddress) {
    t7 = <SearchBar inputAddress={inputAddress} onInputAddressChange={setInputAddress} onSearchChange={handleSearchChange} />;
    $[15] = handleSearchChange;
    $[16] = inputAddress;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== handleHomeIconClick || $[19] !== searchedAddress || $[20] !== t5 || $[21] !== t6 || $[22] !== t7) {
    t8 = <HomeHeader searchedAddress={searchedAddress} isSearchComplete={t5} onHomeIconClick={handleHomeIconClick} queryString={t6}>{t7}</HomeHeader>;
    $[18] = handleHomeIconClick;
    $[19] = searchedAddress;
    $[20] = t5;
    $[21] = t6;
    $[22] = t7;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  return t8;
};
export default MapHomeHeader;